/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/copy-to-clipboard.js":
/*!*************************************!*\
  !*** ./src/js/copy-to-clipboard.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ copyInnerTextToClipboard)
/* harmony export */ });
/*
    * Copy to clickboard function
    *
    * NOTES:
    * 1. Requires the following HTML structure: <p id="copy">code</p><p id="copy-status"></p>
*/
function copyInnerTextToClipboard(event) {
  var copyToClipboard = function copyToClipboard(event) {
    // Only fire if the target has id copy
    if (!event.target.matches("#copy")) {
      return;
    }

    ; // Clipboard API not available

    if (!navigator.clipboard) {
      return;
    }

    ; // Get the text from the target element

    var text = event.target.innerText; // Copy the text to the clipboard

    try {
      navigator.clipboard.writeText(text); // Get the next element with an id of copy-status and update the text if the copy is successful

      var statusText = event.target.nextElementSibling; // if the next element does not have an id of copy-status, return

      if (statusText.id != "copy-status") return; // update the status text

      statusText.innerText = "Code Copied!";
    } catch (err) {
      console.error("Copy Failed!", err);
    }
  };

  document.addEventListener("click", function (event) {
    return copyToClipboard(event);
  });
}

/***/ }),

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "".concat(window.theme.moneyFormat);

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

/***/ }),

/***/ "./src/js/swatches.js":
/*!****************************!*\
  !*** ./src/js/swatches.js ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ swatches)
/* harmony export */ });
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function swatches() {
  // L.G. Function to output the grouped swatches and trigger
  var outputGroupedProducts = function outputGroupedProducts(data, currentProductID) {
    // L.G. Save the data to a variable
    var dataObject = data; // L.G. Map the data to a new array

    var products = dataObject.products.map(function (product) {
      return {
        id: product.id,
        title: product.title,
        url: product.url,
        image: product.featured_image,
        available: product.available,
        colour: product.colour_name,
        active: 'border-grey-100'
      };
    }); // L.G. Get product count

    var productCount = products.length; // L.G. Select the container for the swatches

    var productColours = document.querySelector('.product-colours'); // L.G. Select the swatch title

    var productColoursSelection = document.querySelector('.product-colours-selection'); // L.G. Check if the container exists, else return out of the function

    if (productColours == null) return;
    if (productColoursSelection == null) return; // L.G. Loop through the products and output the markup

    products.map(function (product, index) {
      // L.G. Set the variable to hold the links to be hidden
      var hideSwatches = ''; // L.G. If the product count is greater than 6 and the index is greater than 5, hide the links in the markup

      if (index >= 5 && productCount > 6) {
        hideSwatches = 'hidden';
      } // L.G. If the product is the current product, set the active class


      product.id == currentProductID ? product.active = 'border-black' : product.active = 'border-grey-100'; // L.G. If the product is the current product, set the colour name

      if (product.id == currentProductID && productColoursSelection != null) {
        productColoursSelection.textContent = product.colour;
      } // L.G. Create the markup for each link and trigger to show more products


      var productMarkup = "\n                <a href=\"".concat(product.url, "\" class=\"swatch w-full border border-2 ").concat(product.active, " hover:border-black ").concat(hideSwatches, "\"\n                    data-product-id=\"").concat(product.id, "\"\n                    data-product-available=\"").concat(product.available, "\" \n                    aria-label=\"View ").concat(product.title, "\" \n                    tabindex=\"0\">\n                    <img src=\"").concat(product.image, "\" alt=\"").concat(product.title, "\">\n                    <span class=\"sr-only\">View ").concat(product.title, " in ").concat(product.title, "</span>\n                </a>\n            ");
      var triggerMarkup = "\n                <button class=\"swatch__trigger flex items-center justify-center w-full border border-2 border-grey-100 hover:border-black text-[15px]\">\n                    +".concat(productCount - 5, "\n                </button>\n            "); // L.G. Insert the markup and trigger 

      productColours.insertAdjacentHTML('beforeend', productMarkup);

      if (index === 4 && productCount > 6) {
        productColours.insertAdjacentHTML('beforeend', triggerMarkup);
      } // L.G. Add the event listener to the trigger and show the swatches


      function swatchTrigger() {
        var trigger = document.querySelector('.swatch__trigger');

        var swatches = _toConsumableArray(document.querySelectorAll('.swatch')); // L.G. Check if the trigger exists and add the event listener


        var checkTriggerExists = setInterval(function () {
          if (trigger != null) {
            trigger.addEventListener('click', function () {
              swatches.map(function (swatch) {
                return swatch.classList.remove('hidden');
              });
              trigger.classList.add('hidden');
            });
            clearInterval(checkTriggerExists);
          }
        }, 100);
      }

      swatchTrigger();
    });
  };

  var getGroupedProductData = function getGroupedProductData() {
    // L.G. Get the product colours container
    var productColoursContainer = document.querySelector('.product-colours-container'); // L.G. If the product colours container doesn't exist, return

    if (productColoursContainer == null) {
      return;
    } // L.G. Get the product colours tag and the current product ID


    var productColoursTag = productColoursContainer.getAttribute('data-colour-group');
    var currentProductID = parseInt(productColoursContainer.getAttribute('data-current-product-id'));
    var url = "/collections/all/".concat(productColoursTag, "?view=swatches"); // L.G. Fetch the data

    fetch(url).then(function (response) {
      return response.json();
    }).then(function (data) {
      outputGroupedProducts(data, currentProductID);
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  };

  getGroupedProductData();
}

/***/ }),

/***/ "./node_modules/smooth-zoom/dist/zoom.esm.js":
/*!***************************************************!*\
  !*** ./node_modules/smooth-zoom/dist/zoom.esm.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zoom)
/* harmony export */ });
function Zoom(target, options = {}) {
  const originalizer = options.originalizer || (src => src);

  const screenSize = {
    screenWidth: 0,
    screenHeight: 0,
    scrollBar: 0
  };
  const background = options.background;

  const updateScreenSize = () => {
    const {
      documentElement
    } = document;
    screenSize.screenWidth = window.innerWidth || documentElement.clientWidth;
    screenSize.screenHeight = window.innerHeight || documentElement.clientHeight;
    screenSize.scrollBar = screenSize.screenWidth - documentElement.offsetWidth;
  };

  const zoom = image => {
    const src = image.currentSrc || image.src;
    const {
      srcset
    } = image;
    const {
      screenWidth,
      screenHeight,
      scrollBar
    } = screenSize;
    const {
      width,
      height,
      left,
      top
    } = image.getBoundingClientRect();
    const wrapX = (screenWidth - scrollBar) / 2 - left - width / 2;
    const wrapY = -top + (screenHeight - height) / 2;
    const bg = document.createElement("div");
    const imageClone = document.createElement("img");
    let maxWidth = image.naturalWidth;

    const removeImage = () => {
      bg.classList.remove("zoom-bg--reveal");
      imageClone.style.transform = "";
      imageClone.addEventListener("transitionend", () => {
        bg.remove();
        image.classList.remove("zoom-original--hidden");
        imageClone.remove();
      }, {
        once: true
      });
      bg.removeEventListener("click", removeImage);
      imageClone.removeEventListener("click", removeImage);
      window.removeEventListener("scroll", removeImage);
      window.removeEventListener("resize", removeImage);
    };

    bg.classList.add("zoom-bg");

    if (background) {
      if (background === "auto") {
        const average = getAverageRGB(image);
        bg.style.background = average ? `rgb(${average.r}, ${average.g}, ${average.b})` : "rgb(0, 0, 0)";
      } else {
        bg.style.background = background;
      }
    }

    if (srcset) {
      const sizes = srcset.match(/ ([0-9]+)w/gm);

      if (sizes) {
        // Find image's largest width in 'srcset' attribute
        maxWidth = sizes.map(x => +x.trim().replace("w", "")).filter(x => !isNaN(x)).reduce((acc, cur) => Math.max(acc, cur), 0);
      }
    }

    const ratio = height / width; // Image's width shouldn't be larger than screen width

    maxWidth = Math.min(maxWidth, screenWidth); // And height too

    const maxHeight = maxWidth * ratio;

    if (maxHeight >= screenHeight) {
      maxWidth = maxWidth * screenHeight / maxHeight;
    }

    imageClone.classList.add("zoom-img");
    imageClone.src = src;
    imageClone.width = width;
    imageClone.height = height;
    bg.addEventListener("click", removeImage, {
      once: true
    });
    imageClone.addEventListener("click", removeImage, {
      once: true
    });
    window.addEventListener("scroll", removeImage, {
      once: true,
      passive: true
    });
    window.addEventListener("resize", removeImage, {
      once: true,
      passive: true
    });
    document.body.append(bg, imageClone); // Added here for causing style recalculation

    imageClone.style.top = `${top + window.scrollY}px`;
    imageClone.style.left = `${left}px`;
    imageClone.style.width = `${width}px`;
    imageClone.style.height = `${height}px`; // Hide original image

    image.classList.add("zoom-original--hidden"); // Reveal and center cloned image, scale up if needed

    const scale = maxWidth !== width ? maxWidth / width : 1;
    imageClone.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${wrapX}, ${wrapY})`;
    bg.classList.add("zoom-bg--reveal");
    imageClone.addEventListener("transitionend", () => {
      // Replace image's source to original source
      imageClone.src = originalizer(src);
    }, {
      once: true
    });
  };

  const handleClick = event => {
    zoom(event.target);
  };

  const getAverageRGB = img => {
    const blockSize = 5;
    const rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const width = canvas.width = img.naturalWidth || img.offsetWidth || img.width;
    const height = canvas.height = img.naturalHeight || img.offsetHeight || img.height;
    let data;
    let i = -4;
    let length;
    let count = 0;
    ctx.drawImage(img, 0, 0);

    try {
      data = ctx.getImageData(0, 0, width, height);
    } catch (e) {
      return null;
    }

    length = data.data.length;

    while ((i += blockSize * 4) < length) {
      ++count;
      rgb.r += data.data[i];
      rgb.g += data.data[i + 1];
      rgb.b += data.data[i + 2];
    }

    rgb.r = Math.floor(rgb.r / count);
    rgb.g = Math.floor(rgb.g / count);
    rgb.b = Math.floor(rgb.b / count);
    return rgb;
  };

  const attach = target => {
    if (!target) return;

    if (typeof target === "string") {
      document.querySelectorAll(target).forEach(addZoomEvent);
    } else if (target instanceof HTMLElement) {
      addZoomEvent(target);
    } else if (target instanceof NodeList || target instanceof Array) {
      target.forEach(addZoomEvent);
    } // Add cursor style for target


    if (typeof target === "string") {
      const style = document.createElement("style");
      const head = document.head || document.getElementsByTagName("head")[0];
      style.appendChild(document.createTextNode(`${target}{cursor:zoom-in}`));
      head.appendChild(style);
    }
  };

  const addZoomEvent = element => {
    if (!(element instanceof HTMLElement)) return;

    if (element.tagName === "IMG") {
      element.addEventListener("click", handleClick);
    } else {
      const childImg = element.querySelector("img");

      if (childImg) {
        childImg.addEventListener("click", handleClick);
      }
    }
  };

  updateScreenSize();
  window.addEventListener("resize", updateScreenSize, {
    passive: true
  });
  attach(target);
  return {
    zoom,
    attach
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out;will-change:transform}.zoom-bg{background:#121212;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw;will-change:opacity}.zoom-bg.zoom-bg--reveal{opacity:.95}.zoom-original--hidden{visibility:hidden}";
styleInject(css_248z);




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smooth_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js");
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");
/* harmony import */ var _swatches__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./swatches */ "./src/js/swatches.js");
/* harmony import */ var _copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./copy-to-clipboard */ "./src/js/copy-to-clipboard.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





/*
 BG: Init smooth-zoom, just apply the class below a zoomable image
https://github.com/marshall-ku/smooth-zoom
 */

(0,smooth_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])(".zoomable");
/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */

var productVariants = function productVariants() {
  var productVariants = document.querySelector('#product-variants'); //If there are no variants, we don't need to run this function.

  if (productVariants == null || productVariants == undefined) {
    return;
  }

  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll('fieldset');
  var masterVariantField = document.querySelector('.product-info form input[name="id"]'); // TODO: Form was actioning action attribute of form and was trying to target "/cart/add".
  // On multi sites this was breaking on sites with multi language as cart is "/fr-fr/cart/add" as an example.

  var cartBtn = document.querySelector('.product-info .btn-add-to-cart'); //get the variantData from the json markup.

  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  }; //Debug
  //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));


  var updateSelectSizeBtn = function updateSelectSizeBtn(radio) {
    var selectSizeBtn = document.querySelector('.js-select-size-btn');
    var buttonLabel = selectSizeBtn.getAttribute('data-selected-size');
    var label = radio.labels[0];
    var activeLabelSize = label.querySelector('.js-active-size').getAttribute('data-size');
    selectSizeBtn.querySelector('.js-btn-text').innerHTML = buttonLabel + ': ' + '<span class="uppercase text-[#59595b]">' + activeLabelSize + '</span>';
  }; //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.


  var addToBagBtn = function addToBagBtn(available) {
    var icon = "<svg width='18' height='22' viewBox='0 0 18 22' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='1.49121' y='5.0647' width='15' height='15' stroke='currentColor' stroke-width='2'></rect><path d='M5.99121 7.5647V1.0647H12.4912V7.5647' stroke='currentColor' stroke-width='2'></path></svg>";

    if (available) {
      cartBtn.classList.remove('btn-disabled');
      cartBtn.classList.add('btn-primary');
      cartBtn.innerHTML = icon + window.product.addToCart;
      cartBtn.disabled = false;
    } else {
      cartBtn.classList.add('btn-disabled');
      cartBtn.classList.remove('btn-primary');
      cartBtn.innerHTML = icon + window.product.soldOut;
      cartBtn.disabled = true;
    }
  }; //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price


  var variantPrice = function variantPrice(variantId) {
    var productPrice = _toConsumableArray(document.querySelectorAll('.js-product-price'));

    var productCAP = _toConsumableArray(document.querySelectorAll('.js-product-compare-at-price'));

    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    }); // Get text for was/now text from data attributes

    var wasPricingText = document.querySelector('.js-product-compare-at-price').getAttribute('data-was-pricing-text');
    var nowPricingText = document.querySelector('.js-product-price').getAttribute('data-now-pricing-text'); //Update each iteration of the product price, with the selected variant, and format the money.

    productPrice.map(function (price) {
      return price.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].price, window.theme.moneyFormat);
    }); //Is there a Compare at price (CAP)? if so, let's update that too. 

    if (variantData[0].compare_at_price != null) {
      //Update each iteration of the product CAP, with the selected variant, and format the money.
      productCAP.map(function (cap) {
        //if CAP does exist, remove the hidden class if present.
        cap.classList.remove('hidden'); //Update the CAP, with the selected variant, and format the money.

        cap.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat); // If the CAP is less than the price, let's add some 'WAS/NOW text.

        cap.insertAdjacentHTML('afterbegin', '<span>' + wasPricingText + '&nbsp;</span>');
      }); // Update each iteration of the product price.

      productPrice.map(function (price) {
        //If the CAP is less than the price, let's add a class to the price to make it red.
        price.classList.add('text-[#AF1313]'); // If the CAP is less than the price, let's add some 'WAS/NOW text.

        price.insertAdjacentHTML('afterbegin', '<span>' + nowPricingText + '&nbsp;</span>');
      });
    } else {
      // Iterate through the CAPs and add the hidden class if not present.
      productCAP.map(function (cap) {
        return cap.classList.add('hidden');
      }); // Iterate through the prices and remove the red class if present.

      productPrice.map(function (price) {
        return price.classList.remove('text-[#AF1313]');
      });
    }
  };
  /**
   * LG: Gets varaint data to calculate sale savings and then updates the DOM.
   */


  var saleSaving = function saleSaving(variantId) {
    // LG. Get the element to update
    var productSavingEl = document.querySelector('.js-product-savings'); // LG. Get the text to update

    var productSavingsText = document.querySelector('.js-product-savings').getAttribute('data-savings-text'); // LG. Get the variant data

    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    }); // LG. Get the variant price and compare at price from data

    var variantPrice = variantData[0].price;
    var variantCAP = variantData[0].compare_at_price;

    if (variantCAP) {
      productSavingEl.classList.remove('hidden');
    } else {
      productSavingEl.classList.add('hidden');
    } // LG. Get sales percentage off     


    var saleSaving = (variantCAP - variantPrice) / variantCAP * 100; // LG. Round to nearest whole number

    saleSaving = Math.round(saleSaving); // Update the DOM. If element is not present, don't update.

    if (productSavingEl) {
      productSavingEl.innerHTML = saleSaving + productSavingsText;
    }
  };
  /**
   * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice. 
   */


  var finalVariant = function finalVariant(variant) {
    // console.log(masterVariantField);
    //BG: let's update the id input to the selected variant id
    masterVariantField.value = variant.id; //BG: Trigger the price update based on the variant ID

    variantPrice(variant.id); //BG: Update the add to bag btn based on the variant being available or not.

    addToBagBtn(variant.available);
    saleSaving(variant.id); //Update the url with the user's variant choice.
    //Get the current URL without parameters

    var currentURLWithoutParams = window.location.href.split('?')[0]; //update the page url with paramters

    history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
  };
  /**
   * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice. 
   * checkedBtns(Array) - Checked radio buttons.
   */


  var remainingOptions = function remainingOptions(checkedBtns) {
    //If only one variant, remove all unavailable classes.
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
        label.classList.remove('js-unavailable-variant');
      });
    } // for each checked radio button.


    checkedBtns.forEach(function (radio, index) {
      //First fieldset option
      if (index === 0) {
        //console.log('fire option 1');
        var remainingVariants; //if only one variant, then find all the unavailable variants

        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } //console.log(index);
        //console.log({remainingVariants});


        remainingVariants.forEach(function (variant) {
          //if one variant, highlight the unavailable options.
          if (variantFieldsets.length === 1) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          } //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.


          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
            }
          } //if there is three variants, same as above.


          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      } //Second Radio Option


      if (index === 1) {
        //console.log('fire option 2');
        var _remainingVariants;

        if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } //console.log(index);
        //console.log({remainingVariants});


        _remainingVariants.forEach(function (variant) {
          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }
          } //if there is three variants, same as above.


          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      } //Third Radio Option


      if (index === 2) {
        //console.log('fire option 3');
        //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
        var _remainingVariants2 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        }); //console.log(index);
        //console.log({remainingVariants});


        _remainingVariants2.forEach(function (variant) {
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          }

          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
          }
        });
      }
    });
  }; //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.  


  radioBtns.forEach(function (radio) {
    return radio.addEventListener('change', function () {
      //After a selection has been made, gather all checked options.
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked'); //By default, we assume there will always be one radio button checked.

      var optionCombine = radioBtnsChecked[0].value; //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.

      if (variantFieldsets.length >= 2) {
        //console.log(radioBtnsChecked[1].value);
        optionCombine += ' / ' + radioBtnsChecked[1].value;
      } //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.


      if (variantFieldsets.length > 2) {
        //console.log(radioBtnsChecked[2].value);
        optionCombine += ' / ' + radioBtnsChecked[2].value;
      } //console.log({optionCombine});
      //BG: with the combined result we search for the variant based on the variant.title.


      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine;
      }); //console.log({combineVariant});

      finalVariant(combineVariant[0]);
      updateSelectSizeBtn(radio);
      remainingOptions(radioBtnsChecked);
    });
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
};

productVariants();
document.addEventListener('DOMContentLoaded', function () {
  (0,_swatches__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__["default"])(); // swymPDP();
});
})();

/******/ })()
;